<template>
  <div v-if="legendOptions.showCustom">
    <b-row v-if="orient=='horizontal'" class="px-2 pb-3 small" style="justify-content: center;" data-testid="lblVisualizationLegend">
      <b-col v-for="(data,i) in legendOptions.data" :key="value[i]" 
                  style="flex-grow:0;white-space:nowrap;"
                  :class="deselected.includes(data.name) ? 'text-muted' : '' "
                  @mouseover="dispatchEvent(data.name, 'highlight')" 
                  @mouseout="dispatchEvent(data.name,'downplay')" 
                  @click="dispatchEvent(data.name, 'select')">
        <i :class="`fa fa-${getIconForSeries(data,i+1)}`" :style="`color:${value[i]}`" /> <span class="pointer ml-1">{{ data.name ? data.name : data }}</span>
      </b-col>
    </b-row>
    <b-col v-if="orient=='vertical'" class="px-2 pb-3 small" data-testid="lblVisualizationLegend">
      <div v-for="(data,i) in legendOptions.data" :key="i" 
                  style="flex-grow:0;white-space:nowrap;"
                  @mouseover="dispatchEvent(i, 'highlight')" 
                  @mouseout="dispatchEvent(i,'downplay')" 
                  @click="dispatchEvent(i, 'select')">
        <i :class="`fa fa-${getIconForSeries(data,i)}`" :style="`color:${value[i]}`" /> <span class="pointer ml-1">{{ data.name ? data.name : data }}</span>
      </div>
    </b-col>
  </div>
</template> 

<script>

export default {
  name : 'visualization-legend',
  props : {
    value : { //color
      type : Array
    },
    legendOptions : {
      type : Object
    },
    chartRefName: {
      type : String
    },
    rendered: {
      type : Boolean
    },
    series: {
      type : Array
    }

  },
  data() {
    return {
      NON_LEGEND_COLOR : "#ff0000",
      colors: {
        blue: "#0000ff",
        brown: "#a52a2a",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgrey: "#a9a9a9",
        darkgreen: "#006400",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkred: "#8b0000",
        green: "#008000",
        darkviolet: "#9400d3",
        gold: "#ffd700",
        indigo: "#4b0082",
        magenta: "#ff00ff",
        lightblue: "#add8e6",
        lime: "#00ff00",
        purple: "#800080"
      },
      standardTypes : ['line', 'bar', 'scatter'],
      deselected : [],
    }
  },
  methods: {
    getIconForSeries(data,i){
      const dataName = (data.name || data);
      let foundInSeries = null;
      for(let series of this.series){
        if(series.name == dataName || 
              series.data.some(s => s.name == dataName)){
                foundInSeries = series;
                break;
        }
      }
      if (foundInSeries) {
        return ['pie', 'bar', ].includes(foundInSeries.type) ? 'square' : 'minus';
      } else {
        return 'minus';
      }
    },
    dispatchEvent(name, type){
      let mode = null;
      for(let series of this.series){
        if(series.name == name){
          mode = 'series';
          break;
        } 
        if(series.data.some(s => s.name == name)){
          mode = 'data';
          break;
        }
      }
      const seriesName = mode == 'series' ? name : null;
      const dataName = mode == 'data' ? name : null;
      const excludeSeriesId = [];
      
      switch(type){
        case 'highlight':
          this.dispatchHighlight(seriesName, dataName, excludeSeriesId);
          break;
        case 'downplay':
          this.dispatchDownplayAction(seriesName, dataName, excludeSeriesId);
          break;
        case 'select':
          this.dispatchSelect(seriesName, dataName, excludeSeriesId);
          break;
      }
    },
    dispatchHighlight(seriesName, dataName, excludeSeriesId){
      this.parentRef.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
      });
    },
    dispatchSelect(seriesName, dataName, excludeSeriesId){
      this.dispatchDownplayAction(seriesName, dataName, excludeSeriesId);
      const name = seriesName || dataName;
      this.parentRef.dispatchAction({
        type: 'legendToggleSelect',
        name: name
      });
      this.dispatchHighlight(seriesName, dataName, excludeSeriesId);
      if(this.deselected.includes(name)){
        this.deselected = this.deselected.filter(f => f !== name);
      }else{
        this.deselected.push(name);
      }
    },
    dispatchDownplayAction(seriesName, dataName, excludeSeriesId) {
      this.parentRef.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
      });
    },
    processSeriesData(){
      let getColor = this.getColor();
      let colors = [];
      this.series.forEach(e => {
        const isLegend = this.legendOptions.data.find(f=> (f.name || f) == e.name);
        if(!isLegend) colors.push(this.NON_LEGEND_COLOR);
        else{
          let color = getColor.next().value;
          if(!color){
            getColor = this.getColor();
            color = getColor.next().value;
          }
          if(!this.standardTypes.includes(e.type)){
            this.setSpecialType(e.type, color, e);
          }
          colors.push(this.colors[color]);
        }
      });

      this.$emit('input', colors);
    },
    setSpecialType(type, color, series){
      switch(type){
        case 'gauge':
          series.itemStyle.color = color;
          break;
      }
    },
    getColor : function* (){
      const colorKeys = Object.keys(this.colors);
      for (let prop of colorKeys){
        yield prop;
      }
    },
  },
  computed : {
    parentRef(){
      return this.$parent.$refs[this.chartRefName];
    },
    orient(){
      return this.legendOptions.orient;
    },
  },
  watch: {
    series :{
      deep: true,
      handler(){
        this.processSeriesData();
      }
    },
    rendered : {
      deep: true,
      handler(val){
        if(val){
          this.processSeriesData();
        }
      }
    }
  },
  mounted() {
  },
}
</script>